import { usePlatformStore } from '@/store/PlatformStore'
import { Navigate, Outlet } from 'react-router-dom'

export default function ProtectedPlatformRoute() {
  const {
    state: { platformUserInfo },
  } = usePlatformStore()

  if (!platformUserInfo) return <Navigate to='/platform/login' replace />
  return <Outlet />
}
